<template>
    <div class="topbar-container">
        <div class="line"></div>
        <validation-observer v-slot="{ invalid }">
            <validation-provider
                v-if="!isNewPassword"
                rules="required"
                name="密码"
                v-slot="{ errors }"
            >
                <zbPass
                    v-model="formData.currentPassword"
                    placeholder="输入密码"
                    vClass="border-bottom"
                    :message="errors[0]"
                >/></zbPass>
            </validation-provider>
            <validation-provider
                rules="required|password|newPassWord:@密码"
                name="新密码"
                v-slot="{ errors }"
            >
                <zbPass
                    v-model="formData.newPassword"
                    placeholder="新密码 密码由6-12位大小写字母、数字组成"
                    vClass="border-bottom"
                    :message="errors[0]"
                ></zbPass>
            </validation-provider>
            <validation-provider
                rules="required|password|passwordTwo:@新密码"
                name="再次输入新密码"
                v-slot="{ errors }"
            >
                <zbPass
                    v-model="formData.password"
                    vClass="border-bottom"
                    placeholder="再次输入新密码"
                    :message="errors[0]"
                ></zbPass>
            </validation-provider>
            <div class="bh bc footBar">
                <van-button :disabled="invalid" @click="onSaveClick" class="btn btn-goodbuy">
                    <span class="fz_30 btn-span">确认</span>
                </van-button>
            </div>
        </validation-observer>
    </div>
</template>

<script>
import { user } from "@/mixin/user";
import { routeCache } from "@/mixin/cache";
import { uodatePassword, sitePassword } from "@/api/user";
import zbPass from "@/components/input/Pass";
export default {
    mixins: [routeCache, user],
    name: "UserPassWord",
    components: { zbPass },
    data() {
        return {
            isEdit: false,
            formData: {},
            isNewPassword: false
        };
    },
    methods: {
        userLoginend() {
            const me = this,
                params = me.getCache();
            me.$store.state.topBarTitle = params.isNewPassword
                ? "设置密码"
                : "修改密码";
            me.isNewPassword = params.isNewPassword;
        },
        onSaveClick() {
            const me = this,
                fun = me.isNewPassword ? sitePassword : uodatePassword;
            fun(me.formData)
                .then(res => {
                    me.toast.success(
                        me.isNewPassword ? "设置密码成功" : "修改密码成功"
                    );
                    setTimeout(() => {
                        me.backGo();
                    }, 100);
                })
                .catch(() => {});
        }
    }
};
</script>

<style scoped lang="scss">
/deep/ .van-cell {
    padding: 30px;
}
.topbar-container {
    background-color: #fff;
}
.line {
    background: #f1f2f3;
}
.btn-goodbuy {
    width: 460px;
}
.footBar {
    margin-top: calc(100% - 300px);
}
/deep/.border-bottom {
    &:after {
        width: calc(100% - 60px);
        border-color: #dcdcdc !important;
        transform: scaleY(1);
    }
}
</style>

